import {FormularData} from '@/model/form-data';
import {Product} from '@/model/product';
import {addDaysToDate, formatDate, getCurrentDateWithoutTime} from '@/util/date.util';
import {getSelectedProduct} from '@/util/product.util';
import {replaceCommas} from '@/util/number.util';

const LKW_DELAY = 3;
const PKW_DELAY = 1;

export class DeliveryDateService {
  public static getInitialDate(): string {
    const date = getCurrentDateWithoutTime()
    addDaysToDate(date, 1);
    const compensatedDate = this.compensateSunday(date);
    return formatDate(compensatedDate);
  }

  public static calculateMinimumDeliveryDate(formData: FormularData, products: Product[]): string {
    const product = getSelectedProduct(formData, products);
    const deliveryDate = this.getMinimumDeliveryDate(parseFloat(replaceCommas(formData.volume)), product.maxPKWAmount);
    const deliveryDateCompensated = this.compensateSunday(deliveryDate);
    return formatDate(deliveryDateCompensated);
  }

  private static getMinimumDeliveryDate(volume: number, maxVolumeForPkw: number): Date {
    const date = getCurrentDateWithoutTime();
    if (volume > maxVolumeForPkw) {
      addDaysToDate(date, LKW_DELAY);
    } else {
      addDaysToDate(date, PKW_DELAY);
    }
    return date;
  }

  private static compensateSunday(date: Date): Date {
    if (date.getDay() === 0) { // 0 = sunday
      addDaysToDate(date, 1);
    }
    return date;
  }
}
